import React from 'react';
import { ICONS } from '../data/icons';

export default function IconPickerModal({ open, currentIconKey, onSelect, onClose }) {
  if (!open) return null;
  return (
    <div
      style={{
        display: 'flex', position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,.45)', backdropFilter: 'blur(4px)',
        zIndex: 8000, alignItems: 'center', justifyContent: 'center',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: 'var(--surface)', border: '1px solid var(--border)',
        borderRadius: 'var(--r-xl)', padding: 24, maxWidth: 420, width: '92%',
        boxShadow: 'var(--shadow-lg)', animation: 'modalIn .2s ease',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <span style={{ fontSize: 14, fontWeight: 700, color: 'var(--text-1)' }}>Choose Icon</span>
          <button
            onClick={onClose}
            style={{
              width: 28, height: 28, background: 'var(--surface-2)', border: '1px solid var(--border)',
              borderRadius: 'var(--r-sm)', display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', fontSize: 16, color: 'var(--text-3)', lineHeight: 1,
            }}
          >✕</button>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 8 }}>
          {Object.entries(ICONS).map(([key, ico]) => (
            <div key={key} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5 }}>
              <div
                onClick={() => onSelect(key)}
                style={{
                  width: 44, height: 44, background: '#1e293b', borderRadius: 'var(--r-md)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer',
                  border: `2px solid ${currentIconKey === key ? 'var(--accent)' : 'transparent'}`,
                  boxShadow: currentIconKey === key ? '0 0 0 3px rgba(99,102,241,.2)' : 'none',
                  transition: 'all .18s',
                }}
              >
                <svg viewBox="0 0 24 24" style={{ width: 20, height: 20, fill: '#fff' }}
                  dangerouslySetInnerHTML={{ __html: ico.svg }} />
              </div>
              <div style={{ fontSize: '9.5px', color: 'var(--text-3)', textAlign: 'center', lineHeight: 1.3, maxWidth: 46 }}>
                {ico.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
